import React, { useState } from 'react';
import { Container, ThisCard } from './styles';

import IconRecursosAtivo from '~/assets/icones/IconRecursosAtivo.svg';
import IconRecursosAtivoB from '~/assets/icones/IconRecursosAtivoB.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  return (
    <Container>
      {data?.map((thisData, i) => (
        <ThisCard
          className={
            linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
          }
          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
          key={thisData?.id || i}
          id={thisData?.id || i}
          index={i}
          ativo={linhaAtiva === thisData?.id ? true : false}
        >
           <div className="card-body">
            <div className="card-text">
              <p className="descricao">#{thisData?.codigo}</p>
              <p className="titulo">{thisData?.titulo}</p>
            </div>
          </div>
          <div className="card">
            <img src={localStorage.getItem("tema") == "E" ? IconRecursosAtivo : IconRecursosAtivoB} alt="Vazio" />
          </div>
        </ThisCard>
      ))}
    </Container>
  );
}

export default CustomBodyContent;
